import { Breakpoint, useBreakpoint } from "cenero-ui-library";
import BookingDetails from "@/components/bookings/details/BookingDetails";
import ModalWrapper from "@/components/shared/ModalWrapper";

// ---------------------- Interface

interface BookingDetailsWrapperProps {
  parentRoute: string;
}

// ---------------------- Component

const BookingDetailsWrapper = ({ parentRoute }: BookingDetailsWrapperProps) => {
  // --------- Variables / Hooks

  const breakpoint = useBreakpoint();

  const isDesktop = breakpoint >= Breakpoint.xl;

  // --------- JSX

  if (isDesktop) {
    return (
      <div className="flex size-full justify-center">
        <div className="size-full max-w-[500px]">
          <BookingDetails parentRoute={parentRoute} />
        </div>
      </div>
    );
  }

  return (
    <ModalWrapper
      title="Booking Details"
      parentRoute={parentRoute}
      content={<BookingDetails parentRoute={parentRoute} />}
    />
  );
};

export default BookingDetailsWrapper;
